import React, { Component } from "react";
import UserAvatar from "react-user-avatar";

import PasswordChangeForm from "../PasswordChange";
import SignOutButton from "../SignOut";
import { AuthUserContext, withAuthorization } from "../Session";

import { SettingOutlined, KeyOutlined } from "@ant-design/icons";

class AccountPage extends Component {
  state = {
    username: "",
  };

  componentDidMount() {
    this.setState({ loading: true });

    var uid = this.props.firebase.auth.currentUser.uid;

    this.props.firebase.users().on("value", (snapshot) => {
      const usersObject = snapshot.val();
      const username = usersObject[uid].username;
      this.setState({
        username: username,
      });
    });
  }

  componentWillUnmount() {
    this.props.firebase.users().off();
  }
  render() {
    return (
      <AuthUserContext.Consumer>
        {(authUser) => (
          <div className="centered-content text-left">
            {this.state.username ? (
              <UserAvatar size="80" name={this.state.username} />
            ) : null}

            <h1 className="header-title">
              <SettingOutlined
                style={{ fontSize: "24px", marginRight: "16px" }}
              />
              Account
            </h1>

            <SignOutButton />

            <h1 className="header-title">
              <KeyOutlined style={{ fontSize: "24px", marginRight: "16px" }} />
              Update password
            </h1>
            <PasswordChangeForm />
          </div>
        )}
      </AuthUserContext.Consumer>
    );
  }
}

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(AccountPage);
